import Decimal from 'decimal.js-light';
import compact from 'lodash/compact';

const addCommas = (number: string) => number.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const formatNumber = (number: string | number | Decimal, decimalPlaces?: number) => {
  const decimal = new Decimal(number);
  const numberAsString = decimalPlaces === undefined ? decimal.toString() : decimal.toFixed(decimalPlaces);
  const parts = numberAsString.split('.');
  return compact([addCommas(parts[0]), parts[1]]).join('.');
};
